var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('page-title',{attrs:{"title":"提现流水"}}),_c('withdraw-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }